/**
 * The self-service permission codes C10 adds.
 *
 * Every one is held by the seeded **Employee** role, which is the test this module
 * applies to any screen proposed for it: if a code here were not granted to somebody
 * with no other standing in the system, the screen belongs in `modules/hr`,
 * `modules/payroll` or `modules/roster` instead.
 *
 * Each is scoped **server-side to the caller's own employee id, resolved from the JWT
 * and never from a parameter** (§5.7). `payroll.svccharge.self` is narrower still: own
 * allocation only, and only for pools in `distributed` status — an employee learning
 * their share before the pool is approved would turn every allocation review into a
 * negotiation.
 */

export const ESS_C10_PERMISSIONS = {
  /** Punch in and out. Never on somebody else's behalf — that is `hr.clock.manage`. */
  clockSelf: 'hr.clock.self',
  /** Own roster lines only. */
  rosterReadOwn: 'roster.roster.read.own',
  /** Own service-charge allocations, distributed pools only. */
  serviceChargeSelf: 'payroll.svccharge.self',
  /** Own year-end statements, issued only. */
  yearEndSelf: 'payroll.year_end.self',
  /** Own employment history, including one's own salary. */
  selfAssignments: 'hr.employee.self.assignments',
} as const

export type EssC10Permission = (typeof ESS_C10_PERMISSIONS)[keyof typeof ESS_C10_PERMISSIONS]
